import React, { useEffect, useState } from 'react';
import { InputGroup } from 'react-bootstrap';
import { SelectAsyncPaginate } from '../../misc/select-async-paginate';

export const RenderComponent = ({
  rightIcon = null,
  isAsyncPagination = false,
  placeholder = '',
  onChange,
  isSecondComp = false,
  isMulti = false,
  inputType = 'text',
  min = null,
  max = null,
  options = [],
  loadMoreOptions,
  key = '',
  value = '' ,
  isLoading = false,
  style = {},
  selectStyles = {},
  inputStyle = {},
  width = 272,
  onSearch = null,
  disabled = false,
  step='1',
  defaultValue,
  onMenuOpen,
  componentKey,
}) => {
  const [newValue, setValue] = useState('');
  useEffect(() => {
    if(typeof value === 'object'){
      if(Object.keys(value || {})?.length){
        setValue(value || '');
      }else{
        setValue('');
      }
    }else{
      setValue(value);
    }

  }, [value]);


  return !isAsyncPagination ? (
    <InputGroup
      style={{
        ...inputStyle,
        margin: 0,
        width: '100%',
        ...(disabled ? { cursor: 'not-allowed',
          background: "var(--grey-5, #F2F2F3)"
         } : {}),
      }}
      className={`search-input-group apply-input-style ${rightIcon ? 'right-icon-input-group': ''}`}
    >
      <input
        className={`form-control ${
          isLoading ? 'input-loading' : ''
        } clear-btn-search ${rightIcon ? 'right-icon' : ''}`}
        type={inputType}
        step={step}
        defaultValue={defaultValue}
        autoComplete="off"
        placeholder={placeholder}
        onChange={({ target: { value = '' } = {} }) => onChange(value)}
        style={{ ...style }}
        min={Number(min || 0)}
        max={max}
        value={newValue}
        disabled = {disabled}
      />
      {rightIcon && (
        <InputGroup.Addon style={{ width: 15 }}>
          <img src={rightIcon} alt="right icon" />
        </InputGroup.Addon>
      )}
    </InputGroup>
  ) : (
    <InputGroup
      style={{
        width: '100%',
        maxWidth: width,
        marginRight: 0,
        border: 'none',
        ...inputStyle,
      }}
    >
      <SelectAsyncPaginate
        placeholder={placeholder}
        onChange={(value) => onChange(value)}
        width={'100%'}
        maxWidth={width}
        options={options}
        onMenuOpen = {onMenuOpen}
        value={newValue}
        selectStyles = {selectStyles}
        componentKey={componentKey}
        onSearch={onSearch}
        isMulti={isMulti}
        disabled={disabled}
        loadMoreOptions = {loadMoreOptions}
      />
    </InputGroup>
  );
};
